import { render, staticRenderFns } from "./CompetenciesCrud.vue?vue&type=template&id=77479c72&scoped=true"
import script from "./CompetenciesCrud.vue?vue&type=script&lang=js"
export * from "./CompetenciesCrud.vue?vue&type=script&lang=js"
import style0 from "./CompetenciesCrud.vue?vue&type=style&index=0&id=77479c72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77479c72",
  null
  
)

export default component.exports